const EVENT_NAME = 'dabom:apply-prefill';

let pendingText = '';

export const APPLY_RESULT_MARKER = '[자부담 계산 결과]';

export function setApplyPrefill(text: string): void {
  pendingText = text;
  window.dispatchEvent(new CustomEvent<string>(EVENT_NAME, { detail: text }));
}

export function consumeApplyPrefill(): string {
  const value = pendingText;
  pendingText = '';
  return value;
}

export function subscribeApplyPrefill(handler: (text: string) => void): () => void {
  const listener = (event: Event) => {
    handler((event as CustomEvent<string>).detail);
  };
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}

export function mergeApplyMessage(prev: string, incoming: string): string {
  const index = prev.indexOf(APPLY_RESULT_MARKER);
  const base = (index >= 0 ? prev.slice(0, index) : prev).trimEnd();
  const merged = base ? `${base}\n\n${incoming}` : incoming;
  return merged.slice(0, 500);
}